import { render, staticRenderFns } from "./BasePageHeader.vue?vue&type=template&id=12191b3e&scoped=true&"
import script from "./BasePageHeader.vue?vue&type=script&lang=js&"
export * from "./BasePageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12191b3e",
  null
  
)

export default component.exports